import React from "react";


const breathingVideos = [
  { id: 1, title: "4-7-8 Calm Breathing Exercise", youtubeId: "LiUnFJ8P4gM" },
  { id: 2, title: "Wim Hof Method Guided Breathing", youtubeId: "0BNejY1e9ik" },
  { id: 3, title: "Box Breathing Relaxation Exercise", youtubeId: "FDikCuovqxk" },
  { id: 4, title: "Mindfulness Meditation", youtubeId: "eE5Mnqu0QY0" },
  { id: 5, title: "Alternative Nostril Breathing", youtubeId: "xRHMBLgTfYU" },
  { id: 6, title: "Equal Breathing Exercise for Sleep", youtubeId: "4wEDoKm40Yc" },
];

export default function Breathing() {
  return (
    <div className="flex flex-col bg-white min-h-screen">
      <div className="flex flex-grow items-start justify-center px-4 py-8">
        <div className="w-full max-w-6xl">
          <h1 className="text-3xl font-bold mb-6">
            This Month's Breathing Picks
          </h1>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {breathingVideos.map((video) => (
              <div
                key={video.id}
                className="bg-white rounded-lg shadow-md border border-gray-200 flex flex-col overflow-hidden"
              >
                {/* VIDEO EMBED AREA */}
                <div className="relative w-full pb-[56.25%] bg-gray-100">
                  {video.youtubeId.startsWith("VIDEO_ID") ? (
                    <div className="absolute inset-0 flex items-center justify-center text-gray-400 text-sm">
                      Video coming soon
                    </div>
                  ) : (
                    <iframe
                      className="absolute inset-0 w-full h-full"
                      src={`https://www.youtube.com/embed/${video.youtubeId}`}
                      title={video.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  )}
                </div>

                {/* NON-CLICKABLE, NORMAL BLACK TITLE */}
                <div className="w-full text-left px-4 py-3 border-t border-gray-200 font-semibold">
                  {video.title}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

